module.exports = __webpack_public_path__ + "b4694ebf76a48e81f469a200bde67a6f.svg";